import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Card } from 'components/@shared/Card';
import { BackdropLoader } from 'components/@shared/Loaders';
import { useNotifications } from 'hooks/useNotifications';
import { PATH } from 'routes/path';
import { useDidMount } from 'hooks/useDidMount';
import { InvoiceForm } from 'components/Invoices/InvoiceForm';
import { getInvoiceFormData, updateInvoice } from 'services/invoiceService';
import { InvoiceFormData } from 'types/invoice';

const cardStyles = {
    maxWidth: '700px',
    margin: 'auto',
};
export const EditInvoicePage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [initialData, setInitialData] = useState<InvoiceFormData | null>(null);

    const notifications = useNotifications();
    const navigate = useNavigate();
    const { invoiceId, appointmentId } = useParams<{ invoiceId: string; appointmentId: string }>();

    const submitHandler = (form: InvoiceFormData) => {
        setIsLoading(true);
        if (invoiceId && appointmentId) {
            updateInvoice(form, appointmentId, invoiceId)
                .then(() => {
                    notifications.show({ message: 'Invoice successfully updated' });
                    navigate(PATH.INVOICES);
                })
                .finally(() => setIsLoading(false));
        }
    };

    useDidMount(() => {
        if (invoiceId) {
            getInvoiceFormData(invoiceId)
                .then(setInitialData)
                .finally(() => setIsLoading(false));
        }
    });

    if (isLoading) {
        return <BackdropLoader />;
    }

    if (!initialData) {
        return <Typography>No data</Typography>;
    }

    return (
        <Box width="100%" px={2.5} py={2}>
            <Card title="Invoice" sx={cardStyles}>
                <InvoiceForm initialData={initialData} onSubmit={submitHandler} />
            </Card>
            {isLoading && <BackdropLoader />}
        </Box>
    );
};
